import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import LandingPage from "./pages/landingpage/LandingPage";
import RegisterPage from "./pages/registerpage/RegisterPage";
import GetQuote from "./pages/get_a_quotepage/GetQuote";
import AboutUs from "./pages/about-us/AboutUs";
import Services from "./pages/services/Services";
import ContactUs from "./pages/contact-us/ContactUs";
import TrackParcel from "./pages/track-parcel/TrackParcel";
import Faq from "./pages/faqs/Faqs";
import {
  ADRoot,
  ADLandingUI,
  CreateShipmentUI,
  Orders,
  UpdateShipment,
  AdminRegisterForm,
  Analytics,
  LogoutPage,
  AdminProfileSetting,
  AdminLoginForm,
} from "./admin_dashboard";
import TermsAndConditions from "./pages/terms/TermsAndCondition";
import { AuthProvider } from "./contexts/AuthProvider";
import RequiredAuth from "./utilcomponents/RequiredAuth";
// import AdminRegisterForm from "./admin_dashboard";
// import { AdminLoginForm } from "./pages";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <LandingPage />,
      },
      {
        path: "about-us",
        element: <AboutUs />,
      },
      {
        path: "service",
        element: <Services />,
      },
      {
        path: "contact-us",
        element: <ContactUs />,
      },
      {
        path: "track-parcel",
        element: <TrackParcel />,
      },
      {
        path: "faqs",
        element: <Faq />,
      },
      {
        path: "terms-and-condition",
        element: <TermsAndConditions />,
      },
      {
        path: "get-a-quote",
        element: <GetQuote />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },

      {
        path: "DTCL-secured-with-key-admin-login",
        element: <AdminLoginForm />,
      },

      {
        path: "DTCL-secured-with-key-admin-register",
        element: <AdminRegisterForm />,
      },
    ],
  },

  {
    path: "/dctdashboard/admin",
    element: (
      <RequiredAuth>
        {" "}
        <ADRoot />{" "}
      </RequiredAuth>
    ),
    children: [
      {
        path: "",
        element: <ADRoot />,
        children: [
          { path: "", element: <ADLandingUI /> },
          {
            path: "create-shipment",
            element: <CreateShipmentUI />,
          },

          {
            path: "admin-setting",
            element: <AdminProfileSetting />,
          },
          {
            path: "analytics",
            element: <Analytics />,
          },
          {
            path: "update-shipment",
            element: <UpdateShipment />,
          },
          {
            path: "order",
            element: <Orders />,
          },
          {
            path: "logout",
            element: <LogoutPage />,
          },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
